import {gsap} from "gsap";
<template>
	<div class="selectcustomer" ref="back">
		<div class="selectcustomer__box" ref="box" style="overflow: scroll;">
			<div class="selectcustomer__box-title">Unisci clienti</div>
			<span v-if="loading"> {{ $t('common.loading') }} </span>

			<div class="table" v-if="!loading">
				<p v-if="!showList" @click="showList = true" class="merge_title card__header-link" style="cursor: pointer">Visualizza i {{ customers.length }} clienti selezionati.</p>
				<p v-if="showList" @click="showList = false" class="merge_title card__header-link" style="cursor: pointer">Nascondi clienti selezionati</p>
				<br>
				<table v-if="showList">
					<thead>
					<tr>
						<th>Azienda</th>
						<th>Indirizzo</th>
						<th>P.Iva</th>
						<th>E-mail</th>
					</tr>
					</thead>
					<tbody>
						<tr v-for="c in customers">
							<td><strong>{{ c.agency }}</strong><br>
							<small>{{ c.first_name }} {{ c.last_name }}</small></td>
							<td>{{ c.address }}<br>{{ c.city }}</td>
							<td>{{ c.vat_number }}</td>
							<td>
								<strong>Email:</strong> {{ c.email }}<br>
								<strong>Email2: </strong>{{ c.email2 }}<br>
								<strong>Email3:</strong> {{ c.email3 }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<br>
			<p class="merge_title" v-if="loading">I dati del cliente unito sarà:</p>
			<form class="form_merge" @submit.prevent="submitForm" v-if="!loading">
				<div class="form__field">
					<label class="form__field-label" :for="$t('customers.agency')">{{ $t('customers.agency') }}</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.agency.$model"/>
					<div class="field__validator_error" v-if="submitted && !$v.form.agency.required">
						{{ $t('customers.errors.agency_required') }}
					</div>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.first_name')}}</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.first_name.$model"/>
					<div class="field__validator_error" v-if="submitted && !$v.form.first_name.required">
						{{ $t('customers.errors.first_name_required') }}
					</div>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.last_name')}}</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.last_name.$model"/>
					<div class="field__validator_error" v-if="submitted && !$v.form.last_name.required">
						{{ $t('customers.errors.last_name_required') }}
					</div>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.address')}}</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.address.$model"/>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.vat_number')}}</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.vat_number.$model"/>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.city')}}</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.city.$model"/>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.email')}}</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.email.$model"/>
					<div class="field__validator_error" v-if="submitted && !$v.form.email.email">
						{{ $t('customers.errors.email_malformed') }}
					</div>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.email')}} 2</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.email2.$model"/>
					<div class="field__validator_error" v-if="submitted && !$v.form.email2.email">
						{{ $t('customers.errors.email_malformed') }}
					</div>
				</div>
				<div class="form__field">
					<label class="form__field-label">{{$t('customers.email')}} 3</label>
					<input type="text" class="form__field-input" v-model.trim="$v.form.email3.$model"/>
					<div class="field__validator_error" v-if="submitted && !$v.form.email3.email">
						{{ $t('customers.errors.email_malformed') }}
					</div>
				</div>
				<div class="form__field">
					<button type="submit" class="btn" :disabled="loading">
						<span v-if="loading">{{ $t('common.loading') }}</span> <span v-if="!loading">
							Unisci
						</span>
					</button>
					<button type="button" @click="close()" class="btn form__field-btn"
							:disabled="loading">
						<span v-if="loading">{{ $t('common.loading') }}</span>
						<span v-if="!loading">
                                    Annulla
                                </span>
					</button>
				</div>
			</form>
		</div>

		<alert-modal v-model="showError" v-bind:title="$t('customers.alert.error.generic.title')"
					 v-bind:text="$t('customers.alert.error.generic.text')"></alert-modal>
		<confirm-modal v-model="modalMergeOpen" v-bind:title="'Unione'"
					   v-bind:text="'Sicuri di voler uniti questi clienti? Questa operazione è irreversibile.'" @result="merge($event)"></confirm-modal>
	</div>
</template>
<script>
    import {required, email} from 'vuelidate/lib/validators'
    import AlertModal from "../../components/AlertModal"
    import ConfirmModal from "../../components/ConfirmModal"
    import {gsap} from 'gsap';

    export default {
        name: 'customer-merge-form',
        components: {AlertModal, ConfirmModal},
        props: {
            customers: {
                required: true
            },
            value: {
                required: true
            }
        },
        data() {
            return {
                user: null,
                showError: false,
                submitted: false,
                error: '',
                loading: false,
                modalMergeOpen: false,
				showList: false,
				customer_id: '',
                form: {
                    agency: '',
                    first_name: '',
                    last_name: '',
                    address: '',
                    vat_number: '',
                    city: '',
                    email: '',
                    email2: '',
                    email3: ''
                }
            }
        },
        // gestione della validazione
        validations: {
            form: {
                agency: {
                    required
                },
                first_name: {
                    required
                },
                last_name: {
                    required
                },
                address: {},
                vat_number: {},
                city: {},
                email: {email},
                email2: {email},
                email3: {email}
            }
        },
        watch: {
            value(v) {
                let modal = this.$refs;
                if (v) {
                    gsap.timeline()
                        .to(modal.back, 0.3, {opacity: 1, pointerEvents: 'all'})
                        .to(modal.box, 0.4, {opacity: 1, y: 0});
                    this.updateCustomers();
                } else {
                    gsap.timeline()
                        .to(modal.box, 0.4, {opacity: 0, y: 60})
                        .to(modal.back, 0.3, {opacity: 0, pointerEvents: 'none'})
                }
            }
        },
        methods: {
            // inizializzo il tutto
            updateCustomers() {
                let d = this.customers.sort((a, b) => {
                    const aData = new Date(a.updated_at);
                    const bData = new Date(b.updated_at);

                    console.log(aData, bData);
                    if(aData.getTime() == bData.getTime()) {
                        return 0;
                    }
                    if(aData.getTime() < bData.getTime()) {
                        return 1;
                    }
                    return -1;
                })

				// prendo il primo che è il più aggiornato
				let last = d[0];
                this.customer_id = last.id;
                this.form.agency = last.agency;
                this.form.first_name = last.first_name;
				this.form.last_name = last.last_name;
				this.form.address = last.address;
				this.form.vat_number = last.vat_number;
				this.form.city = last.city;
				this.form.email = last.email;
				this.form.email2 = last.email2;
				this.form.email3 = last.email3;
            },
			close() {
                this.value = false;
                this.$emit('close');
			},
            submitForm() {
				this.modalMergeOpen = true;
			},
			merge(resultConfirm) {
                if(resultConfirm) {
                    this.submitted = true;
                    this.error = '';
                    this.loading = true;
                    this.$v.$touch();
                    if (!this.$v.$invalid) {
                        this.loading = true;
                        this.api.customers.merge(this.form, this.customer_id, this.customers)
                            .then(() => {
                                this.toast.success();
                                this.value = false;
                                this.$emit('success');
                            })
                            .catch((e) => {
                                this.toast.error(this.$t(`customers.errors.${e.error}`));
                            })
                            .finally(() => {
                                this.submitted = false;
                                this.loading = false;
                            })
                    } else {
                        this.loading = false;
                    }
				}
			}
        }
    }
</script>
<style lang="scss">
	@import './src/scss/variables';
	@import './src/scss/form';

	.merge_title {
		font-weight: 700;
		font-size: 16px;
	}

	.form_merge {
		.form__field {
			display: inline-block;

			&-label {
				line-height: 30px;
			}
		}
	}
</style>
